/* eslint-disable eag/match-named-export -- `noop` does not match the file name */
export const noop = (..._args: any[]): any => {}; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
